import { Cart } from '@peerless/data-access/cart-service/server';
import fetcher from '../client';

export const removeFromCart = (sku: string): Promise<Cart> => {
  return fetcher.post('/cart/remove', { sku });
};
